import type { HardwareProduct } from './hardwareCatalog';

/**
 * SVG paint order for overlapping hardware on the same face.
 * Lower values are painted first (sit behind). Handles sit in front of
 * escutcheons and finger-pulls when artwork overlaps at adjacent anchors.
 */
export function hardwarePaintOrder(product: Pick<HardwareProduct, 'family' | 'role'>): number {
  if (product.role === 'escutcheon' || product.role === 'finger-pull-escutcheon') {
    return 10;
  }
  if (product.family === 'lever' || product.family === 'pull-bar') {
    return 20;
  }
  return 15;
}

export interface HardwarePaintSortItem<TProduct extends Pick<HardwareProduct, 'family' | 'role'>> {
  product: TProduct;
  configIndex: number;
}

export function sortHardwareForPaint<TItem extends HardwarePaintSortItem<Pick<HardwareProduct, 'family' | 'role'>>>(
  items: TItem[]
): TItem[] {
  return [...items].sort((left, right) => {
    const orderDiff = hardwarePaintOrder(left.product) - hardwarePaintOrder(right.product);
    return orderDiff !== 0 ? orderDiff : left.configIndex - right.configIndex;
  });
}
